/* global window */

import AccountLinks from './AccountLinks';
import AiOutlineClose from '../icons/AiOutlineClose';
import AppContext from './context/AppContext';
import { array, bool, object } from 'prop-types';
import Cart from './Cart';
import ContactUsHeader from './ContactUsHeader';
import Container from 'react-bootstrap/Container';
import { FaUser } from 'react-icons/fa';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavigationDropdownMenu from './NavigationDropdownMenu';
import NavigationMobile from './NavigationMobile';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import RxHamburgerMenu from '../icons/RxHamburgerMenu';
import SearchBox from './SearchBox';
import '../styles/Navigation.css';
import protectCopyRight from '../helpers/protectCopyRight';
import { Link } from 'react-router-dom';


const Navigation = ({ navData, isMobile, searchBoxRef }) => {
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    const navbarRef = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const [searchLoaded, setSearchLoaded] = useState(false);
    const [productList, setProductList] = useState([]);
    const [searchQuery, setSearchQuery] = useState({
        q: '',
        v: '',
        sortBy: '',
        limit: appConfig.defaultLimitPerPage,
        page: 0,
        minPrice: '',
        maxPrice: '',
        t: [],
        c: [],
    });

    useEffect(() => {
        const detectOutsideClick = (e) => {
            if (navbarRef.current !== null && expanded === true
                && !navbarRef.current.contains(e.target)) {
                setExpanded(false);
            }
            if (navbarRef.current !== null && expanded === true
                && navbarRef.current.contains(e.target) && e.target.tagName === 'A'
                && !e.target.classList.contains('dropdown-toggle')) {
                setExpanded(false);
            }
        };
        window.addEventListener('click', detectOutsideClick, true);
        return () => {
            window.removeEventListener('click', detectOutsideClick, true);
        };
    }, [expanded]);

    const handleSetExpandedTrue = useCallback(() => setExpanded(true), [setExpanded]);
    const handleSetExpandedFalse = useCallback(() => setExpanded(false), [setExpanded]);

    return (<Navbar
        variant={'light'}
        expand={isMobile === false ? 'lg' : false}
        className={`main-container navbar__ab ${(expanded && !isMobile) ? 'desktop-expanded' : ''}`}
        expanded={expanded}>
        <Container
            className={'nav-first-level'}>
            <div
                className={'navigation--contact-and-links'}>
                <ContactUsHeader />
                <AccountLinks />
            </div>
            <div
                className={'navigation--toggle-and-brand'}>
                <div
                    className={'d-flex'}>
                    <div
                        className={'navigation--toggle'}>
                        <Navbar.Toggle
                            aria-controls={'basic-navbar-nav'}>
                            {expanded === false && (<RxHamburgerMenu
                                size={'35px'}
                                onClick={handleSetExpandedTrue} />)}
                            {expanded === true && (<AiOutlineClose
                                size={'35px'}
                                onClick={handleSetExpandedFalse} />)}
                        </Navbar.Toggle>
                        <NavigationMobile
                            navData={navData}
                            ref={navbarRef} />
                    </div>
                    <Navbar.Brand
                        as={Link}
                        to={'/'}>
                        <img
                            onContextMenu={protectCopyRight}
                            src={appContext.config.storeLogoUrl}
                            className={'d-inline-block align-top nav-logo'}
                            style={{
                                transition: '0.4s width ease-in-out',
                                objectFit: 'contain',
                            }}
                            width={188}
                            height={56}
                            alt={appContext.config.storeName}
                        />
                    </Navbar.Brand>
                </div>
                <div
                    className={'navigation--mobile-icons'}>
                    <Link
                        to={'/myaccount.asp'}
                    >
                        <FaUser
                            className={'navigation--mobile-icons__user'}
                            size={'23px'} />
                    </Link>
                    <Cart />
                </div>
            </div>
            <div
                className={'navigation--search-and-cart'}>
                <SearchBox
                    isMobile={isMobile}
                    searchLoaded={searchLoaded}
                    setSearchLoaded={setSearchLoaded}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    productList={productList}
                    ref={searchBoxRef}
                    setProductList={setProductList} />
                <Cart />
            </div>
        </Container>
        <Container
            className={'nav-second-level'}>
            <Nav
                className={'navigation--menu'}>
                {navData.map((navLink) => <NavigationDropdownMenu
                    key={navLink.id}
                    navLink={navLink} />)}
            </Nav>
        </Container>
    </Navbar>);
};

Navigation.propTypes = {
    navData: array,
    isMobile: bool,
    searchBoxRef: object,
};

export default Navigation;